/**
 * 認証トークンブリッジ（React コンテキスト → Apollo link）
 *
 * 認証の真実の源（SSOT）は next-auth の SessionProvider（`useSession()`）。
 * ただし Apollo Client の link は React コンテキスト外で動くため、`useSession()` の値を
 * 直接読めない。そこで「React 側が最新 idToken を module-level の ref に push し、
 * link 側はその ref を同期的に read する」という受動的なブリッジを提供する。
 *
 * これにより:
 *  - link は `getSession()`（= /api/auth/session への HTTP fetch）を一切呼ばない
 *    → GraphQL operation ごとの fetch 重複（パフォーマンス劣化）が構造的に消える
 *  - `update()` / 再ログイン等で session が更新されると React 側 useEffect が ref を即更新
 *    → link は常に最新トークンを送る（古いトークンを握り続ける回帰が起きない）
 *
 * トークンのライフサイクル（発行・refresh・失効）はすべて next-auth(JWT callback) と
 * auth-middleware が所有する。この ref はあくまで「最新の写し」を運ぶだけで、
 * トークン管理ロジックは一切持たない。
 *
 * セキュリティ: ここに保持するのは短命の idToken のみ。refresh_token は絶対に置かない
 * （refresh_token は httpOnly cookie 内の next-auth JWT にのみ存在する）。
 */

let currentIdToken: string | null = null;

/** React 側（SessionProvider 配下）から最新 idToken を同期する。ログアウト時は null。 */
export function setCurrentIdToken(token: string | null): void {
  currentIdToken = token;
}

/** Apollo link 等から最新 idToken を同期的に取得する（fetch は発生しない）。 */
export function getCurrentIdToken(): string | null {
  return currentIdToken;
}
